import { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import HomePage from './pages/HomePage';
import { PAGE_MANIFEST } from './data/pageManifest';
import { onAnalyticsReady, trackPageView } from './lib/analytics';

function AnalyticsRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    let timeoutId = 0;
    const unsubscribe = onAnalyticsReady(() => {
      timeoutId = window.setTimeout(trackPageView, 100);
    });
    return () => {
      unsubscribe();
      window.clearTimeout(timeoutId);
    };
  }, [location.pathname, location.search]);

  return null;
}

const AboutPage = lazy(() => import('./pages/AboutPage'));
const DitratorApp = lazy(() => import('./ditrator/DitratorApp'));
const LegacyPage = lazy(() => import('./pages/LegacyPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

function legacyRoutes() {
  return PAGE_MANIFEST.flatMap((page) => {
    const paths = [page.slug, `${page.slug}.html`];
    return paths.map((path) => (
      <Route
        key={path}
        path={`/${path}`}
        element={
          <Suspense fallback={null}>
            <LegacyPage page={page} />
          </Suspense>
        }
      />
    ));
  });
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AnalyticsRouteTracker />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/quem-somos-innovanow" element={<Suspense fallback={null}><AboutPage /></Suspense>} />
          <Route path="/quem-somos-innovanow.html" element={<Suspense fallback={null}><AboutPage /></Suspense>} />
          <Route
            path="/ditrator"
            element={
              <Suspense fallback={null}>
                <DitratorApp />
              </Suspense>
            }
          />
          <Route
            path="/ditrator/*"
            element={
              <Suspense fallback={null}>
                <DitratorApp />
              </Suspense>
            }
          />
          {legacyRoutes()}
          <Route
            path="/404"
            element={
              <Suspense fallback={null}>
                <NotFoundPage />
              </Suspense>
            }
          />
          <Route
            path="/404.html"
            element={
              <Suspense fallback={null}>
                <NotFoundPage />
              </Suspense>
            }
          />
          <Route
            path="*"
            element={
              <Suspense fallback={null}>
                <NotFoundPage />
              </Suspense>
            }
          />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}
